import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withKeys as _withKeys, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen flex justify-center items-center bg-white" }
const _hoisted_2 = { class: "p-10 border-[1px] -mt-10 border-slate-200 rounded-md flex flex-col items-center space-y-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "justify-center text-center" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-3 text-4xl font-extrabold text-dark-grey-900" }, "Fale conosco"),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-4 text-grey-700" }, "Informe o seu nome e email para conversar")
], -1)
const _hoisted_4 = { class: "flex flex-col space-y-5 w-full" }
const _hoisted_5 = ["disabled", "onKeyup"]

import { ref, watch, computed, onMounted } from 'vue'
    import Icon from '@/components/Icon/IndexIcon.vue'
    import { useWebChatFullStore } from '@/stores/webChatFull'
    import FormInput from '@/components/Form/FormInput.vue'
    import services from '@/services'
    import {PageLogin, ValidationLogin, itemWebChatFull } from '@/types/webChatFull'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'PageLogin',
  setup(__props) {

    const isLoading = ref(false)
    const pageLogin = ref<PageLogin>({
        name: ' ',
        email: ' ',
        user: ' ',
        text: 'Enviar uma mensagem',
        icon: 'Send',
    })

    const validation = ref<ValidationLogin>({
        name: '',
        email: '',
    })

    const webChatFullStore = useWebChatFullStore()

    const isWebChatFull = computed(() => webChatFullStore.me)
    const isValidation = computed(() => {
        return validation.value.name.length === 0 && validation.value.email.length === 0
    })

    function getPayloadLogin () {
        // atualizo o store com os dados do usuario
        if(pageLogin.value.name !== undefined && pageLogin.value.email !== undefined) {
            webChatFullStore.update({
                name: pageLogin.value.name,
                email: pageLogin.value.email,
            } as itemWebChatFull)
        }

        return {
            name: isWebChatFull.value.name,
            email: isWebChatFull.value.email,
            user: isWebChatFull.value.user,
            wsToken: isWebChatFull.value.wsToken,
            apiKey: isWebChatFull.value.apiKey,
            page: isWebChatFull.value.currentPage,
            device: window.navigator.userAgent,
            custom_token: isWebChatFull.value.custom_token,
        }
    }

    function handleSetTokenAndUser(user: string, token: string) {
        webChatFullStore.update({
            user,
            wsToken: token,
        } as itemWebChatFull)
        webChatFullStore.setCurrentComponent('chat')
    }
    function handleError() {
        console.error('[CHAT] Error on mount chat')
        isLoading.value = false
        webChatFullStore.setCurrentComponent('error')
    }
    async function handleLogin() {
        // faço a validação dos campos, nao podem ser vazios e nao pode existir uma mensagem de erro
        if ((pageLogin.value?.name !== undefined &&  pageLogin.value.name.length === 0)
            || (pageLogin.value?.email !== undefined && pageLogin.value.email.length === 0)
            || !isValidation.value
        ) { return }

        const payload = getPayloadLogin()

        try {
            isLoading.value = true

            const response = await services.webchat.start(payload)
            console.log(response)

            if (response.errors) {
                console.log(response.errors)
                handleError()
                return
            }

            handleSetTokenAndUser(response.user, response.token)

        } catch (error) {
            console.log(error)
            handleError()
        }
    }

    function validateState (key: keyof ValidationLogin): void {
        const vEmail = /\S+@\S+\.\S+/
        const text = pageLogin.value[key]
        if(text === undefined) return
        if (key === 'name' && text.length < 3) {
            setErrorValidate(key, 'Informe um nome válido')
        }else if (key === 'email' && !vEmail.test(text)) {
            setErrorValidate(key, 'Informar um email válido')
        } else if (text.length === 0) {
            setErrorValidate(key, 'Este campo é obrigatório')
        } else {
            setErrorValidate(key, '')
        }
    }

    function setErrorValidate (key: keyof ValidationLogin, value: string): void {
        validation.value[key] = value
    }

    watch(() => isLoading.value, (value) => {
        let payload = {
            text: 'Enviar uma mensagem',
            icon: 'Send',
        }

        if (value) {
            payload.text = 'Carregando...'
            payload.icon = 'loading'
        }
        pageLogin.value = {
            ...pageLogin.value,
            ...payload,
        }
    })

    onMounted(() => {
        pageLogin.value = {
            name: isWebChatFull.value.name ?? '',
            email: isWebChatFull.value.email ?? '',
        }
    })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(FormInput, {
        modelValue: pageLogin.value.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageLogin.value.name) = $event)),
        type: "text",
        label: "",
        class: "p-3 border-[1px] border-neutral-500 rounded-md w-80",
        placeholder: "Informe seu nome",
        "is-loading": isLoading.value,
        "message-error": validation.value.name,
        onValidate: _cache[1] || (_cache[1] = ($event: any) => (validateState('name'))),
        onKeyup: _withKeys(handleLogin, ["enter"])
      }, null, 8, ["modelValue", "is-loading", "message-error", "onKeyup"]),
      _createVNode(FormInput, {
        modelValue: pageLogin.value.email,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((pageLogin.value.email) = $event)),
        type: "email",
        label: "",
        placeholder: "Informe o seu email",
        "is-loading": isLoading.value,
        class: "p-3 border-[1px] border-neutral-500 rounded-md w-80",
        "message-error": validation.value.email,
        onValidate: _cache[3] || (_cache[3] = ($event: any) => (validateState('email'))),
        onKeyup: _withKeys(handleLogin, ["enter"])
      }, null, 8, ["modelValue", "is-loading", "message-error", "onKeyup"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: _normalizeClass(["w-full flex flex-row gap-2 bg-[#0070ba] rounded-3xl p-3 text-white font-bold transition duration-200 hover:bg-[#003087] justify-center items-center", {'opacity-50 cursor-not-allowed': isLoading.value}]),
          disabled: isLoading.value,
          onClick: handleLogin,
          onKeyup: _withKeys(handleLogin, ["enter"])
        }, [
          _createVNode(Icon, {
            name: pageLogin.value?.icon ?? 'send',
            size: "19"
          }, null, 8, ["name"]),
          _createElementVNode("span", null, _toDisplayString(pageLogin.value?.text ?? 'Enviar uma mensagem'), 1)
        ], 42, _hoisted_5)
      ])
    ])
  ]))
}
}

})